import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import { useDeactivateMealCredit } from 'src/components/oneCorp/features/MealCredit/hooks/useDeactivateMealCredit';
import { pushError, pushSuccess } from 'src/utilities/notifications';
import { useSendAnalytics } from 'src/components/AnalyticsProvider/useSendAnalytics';

export interface UseMealCreditHeaderControlProps {
  corpId: string;
  mealCreditId: string;
}

export interface UseMealCreditHeaderControl {
  isDeactivating: boolean;
  showDeactivateModal: boolean;
  deactivateMealCredit: () => Promise<void>;
  confirmDeactivation: () => void;
  closeDeactivateModal: () => void;
}

export const useMealCreditHeaderControl = ({
  corpId,
  mealCreditId,
}: UseMealCreditHeaderControlProps): UseMealCreditHeaderControl => {
  const { push } = useHistory();
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);

  const { sendAnalytics } = useSendAnalytics({
    eventcategory: 'meal credit settings',
  });

  const { deactivateMealCredit, isDeactivating } = useDeactivateMealCredit({
    corpId,
    mealCreditId,
    onSuccess: deactivateMealCreditSuccess,
    onError: deactivateMealCreditError,
  });

  async function deactivateMealCreditSuccess(): Promise<void> {
    sendAnalytics({
      eventaction: 'deactivate meal credit_cta',
    });
    setShowDeactivateModal(false);
    pushSuccess('Your meal credit was deactivated');
    push(`/corporate/enterprise/${corpId}/meal-credits`);
  }

  async function deactivateMealCreditError(): Promise<void> {
    pushError('Your meal credit was not deactivated. Try again.');
  }

  const confirmDeactivation = (): void => {
    setShowDeactivateModal(true);
  };

  const closeDeactivateModal = (): void => {
    setShowDeactivateModal(false);
  };

  return {
    isDeactivating,
    deactivateMealCredit,
    confirmDeactivation,
    showDeactivateModal,
    closeDeactivateModal,
  };
};
